/* eslint no-underscore-dangle: ["error", { "allowAfterThis": true }] */

'use strict';

const { connectState } = require('./container');

class UgcPhotosModel {
  constructor() {
    this.state = this.getState();
  }

  /*
   * currently only gets shallow
  */
  get(prop) {
    if (prop === 'state') {
      return this._clone(this.state);
    }

    const stateProp = this.state[prop];

    switch (stateProp) {
      case Array.isArray(stateProp):
      case typeof stateProp === 'object':
        return this._clone(stateProp);
      default:
        return stateProp;
    }
  }

  /*
   * This base clone should works well for our state object
   * since it should not contain functions
   * or model instances, only primitives, arrays
   * and objects
   *
  */
  _clone(prop) {
    return JSON.parse(JSON.stringify(prop));
  }

  addImages(newImagesByUuid, ids) {
    this.addImagesByIds(ids);
    this.addImagesByUuid(newImagesByUuid);
  }

  getImageData(uuid) {
    if (this.state.imagesByUuid[uuid]) {
      return this.get('imagesByUuid')[uuid];
    }
    return undefined;
  }

  getImageUuid(index) {
    return this.state.ids[index];
  }

  getImageIndex(uuid) {
    return this.state.ids.indexOf(uuid);
  }

  addImagesByUuid(newImagesByUuid) {
    this.setState(prevState => {
      return {
        imagesByUuid: Object.assign(
          {},
          newImagesByUuid,
          prevState.imagesByUuid
        ),
      };
    });
  }

  updateImageData(uuid, props) {
    const imageData = Object.assign({}, this.getImageData(uuid), props);

    this.setState(prevState => {
      return {
        imagesByUuid: Object.assign({}, prevState.imagesByUuid, {
          [`${uuid}`]: Object.assign(
            {},
            prevState.imagesByUuid[`${uuid}`],
            imageData
          ),
        }),
      };
    });
  }

  addImagesByIds(ids) {
    const newIds = ids.reduce((arr, id) => {
      return this.getImageData(id) ? arr : arr.concat(id);
    }, this.state.ids);
    this.setState({ ids: newIds });
  }

  ids() {
    return this.get('ids');
  }

  imagesByUuid() {
    return this.get('imagesByUuid');
  }

  isLoggedIn() {
    return this.get('isLoggedIn');
  }
}

connectState('ugcPhotos', UgcPhotosModel);

module.exports = UgcPhotosModel;



// WEBPACK FOOTER //
// ./modules/ugc_photos/frontend/UgcPhotosModel.js